(() => {
  const openCart = false;
  let url = "\/collections\/products";
  try {
    const raw = localStorage.getItem('isolated_page');
    if (raw) {
      const sep = raw.lastIndexOf('|');
      const path = raw.slice(0, sep);
      const expires = +raw.slice(sep + 1);
      if (path[0] === '/' && path[1] !== '/' && expires > Date.now()) url = path;
      else localStorage.removeItem('isolated_page');
    }
  } catch (e) {
    localStorage.removeItem('isolated_page');
  }
  const u = new URL(url, location.origin);
  if (openCart) u.searchParams.set('open_cart', '1');
  if (location.href !== u.href) location.replace(u.href);
})();
